import React from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet} from 'react-router-dom'
const serverpy_template=`import os
import sys
from flask import Flask, jsonify, request, render_template
from flask_cors import CORS, cross_origin
from dotenv import load_dotenv
load_dotenv()
app = Flask(__name__)
cors = CORS(app, support_credentials=True)
sys.path.insert(0, os.path.dirname(__file__))
@app.route('/')
@cross_origin(supports_credentials=True)
def hello_word():
   return 'Hello World'
if __name__=='__main__': 
   app.run(host="0.0.0.0", port=5000, debug=True) 
`
export default function PythonPage1() {
   return (
      <div className='text-left ml-[4px] mr-[4px] sm:m-auto sm:mt-8 w-auto md:w-[580px] lg:w-[780px]'>
         {/* <h2 className='mb-4 text-lg structure__main__subttl'>Python NodeJS C++  Cookbook</h2> */}
         <h2 className='mb-4 text-lg structure__main__subttl'>Python Cpp Java NodeJS Cookbook</h2>
         <p className='text-sm mb-12'>Listed functions require both frontend with React and backend with Python/Cpp/Java/NodeJS.<br />Those functions require backend to store data at database(AWS, Mongodb, Postgres, mySQL, local JSON file and so on.)<br />
         Also, LLM can be only generated from backend.
         </p>
         <h3 className='text-lg font-bold mb-2'>Quick Start</h3>
         <h3 className='mt-4 text-lg font-bold mb-2'>Frontend</h3>
         <div className='mb-8 text-xs'>
            1. Install zip folder. Open VS code and right click left side of unzipped downloaded folder > <b>client</b> folder to open terminal with right directory.<br/><br/>
            2. Install node-modules and packages<br/>
            <pre className='primary-code-container'>
            npm i
            </pre><br/>
            3. Run<br/>
            <pre className='primary-code-container'>
            npm run start
            </pre> 
         </div>
         <h3 className='mt-4 text-lg font-bold mb-2'>Backend</h3>
         <b className='text-[12px]'>Nodejs</b>
         <div className='mb-8 text-xs'>
            1. Install zip folder. Open VS code and right click left side of unzipped downloaded folder > <b>server_node</b> folder to open terminal with right directory.<br/><br/>
            2. Install node-modules and packages<br/>
            <pre className='primary-code-container'>
            npm i
            </pre><br/>
            3. Run<br/>
            <pre className='primary-code-container'>
            npm run start
            </pre> 
         </div>
         <b className='text-[12px]'>Python</b>
         <div className='mb-8 text-xs'>
            1. Install zip folder. Open VS code and right click left side of unzipped downloaded folder > <b>server_py</b> folder to open terminal with right directory.<br/><br/>
            2. Install python packages<br/>
            Create venv<br/>
            <pre className='primary-code-container'>
            python3 -m venv venv
            </pre><br/>
            Activate venv<br/>You always need to activate when you access terminal from new tab.<br/>
            <pre className='primary-code-container'>
            source venv/bin/activate
            </pre><br/>
            Install packages<br/>You can also manually install by checking code at package tab
            <pre className='primary-code-container'>
            pip install -r requirements.txt<br/>
            </pre><br/>
            Check if all pakcages are installed
            <pre className='primary-code-container'>
            pip freeze
            </pre><br/>
            3. Run<br/>
            <pre className='primary-code-container'>
            python3 server.py
            </pre> 
         </div>
   
         <h3 className='mt-4 text-lg font-bold mb-2'>Jupyter Lab (Optional)</h3>
         <div className='text-xs mb-12'>You can test llm result from jupyter lab.<br/><br/>
         1. Run to open jupyter lab on your browser<br/>
         <pre className='primary-code-container'>
            jupyter lab
         </pre> <br/>
         2. Click test.ipyb and shift+enter code box to run codes.<br/>
         </div>
         <h3 className='mt-4 text-lg font-bold mb-2'>Create environment from scratch (Optional)</h3>
         <div className='text-xs mb-12'>
            <b>1. Create flask & python environment</b><br /><br />
            <b>Install Python 3.11</b><br />
             {/* · Check installed python<br />
            <p className='bg-gray-100 p-2 w-[350px]'>python --version</p><br />
             · Install Python 3.11 manually<br />
             <RouterLink className='text-xs pl-2' to='https://www.python.org/'>url: https://www.python.org/</RouterLink><br /><br />
             · Install Python 3.11 with Homebrew<br />
            <p className='ml-2'>Check installed Homebrew</p>
            <p className='bg-gray-100 p-2 w-[350px]'>brew -v</p>
            <p className='ml-2'>Install Homebrew</p>
            <div className='bg-gray-100 text-xs p-2 w-[350px] wrap-break-word'>/bin/bash -c "$(curl -fsSL https://raw.githubusercontent.com/Homebrew/install/master/install.sh)"</div>
            <p className='ml-2'>Install python with homebrew</p>
            <p className='bg-gray-100 pl-2 p-1 w-[350px]'>brew install python</p><br /> */}
            <br />
            Create folder called flask-folder<br />
            Create .env, requirement.txt, and server.py file inside of flask-folder
            <pre className='primary-code-container'>
               mkdir flask-folder<br/>
               cd ./flask-folder<br/>
               touch server.py<br/>
               {/* touch requirement.txt<br/>
               touch .env<br/> */}
               python3 -m venv venv<br/>
               source venv/bin/activate<br/>
            </pre>
            <br />

            <b>Install backend packages</b><br />
            {/* Click access to flask-folder and open terminal.<br />
             · Check installed packages<br />
            <p className='bg-gray-100 p-2 w-[350px]'>pip freeze</p><br /> */}
             · Create flask env manually and run backend with venv<br />
            <pre className='primary-code-container'>pip install requests python-dotenv flask flask-cors</pre><br />
             {/* · Install all env from requirements.txt<br />
            <p>Create requirements.txt<br />Paste <span className='text-red-700'>requirements.txt</span></p>
            <p className='bg-gray-100 p-2 w-[350px]'>pip install -r requirements.txt</p><br />
            · Install anaconda3 and run backend with anaconda3 *<br />
            <p>Check installed anaconda3</p>
            <p className='bg-gray-100 p-2 w-[350px]'>conda --version</p><br />
            <p>Install anaconda3 manually</p>
            <RouterLink className='text-xs pl-2' to='https://www.anaconda.com/docs/getting-started/anaconda/install'>url: https://www.anaconda.com/docs/getting-started/anaconda/install</RouterLink><br /><br />
            <p>Install anaconda3 from powershell</p>
            <p className='bg-gray-100 p-2 w-[350px]'>wget "https://repo.anaconda.com/archive/Anaconda3-2024.10-1-Windows-x86_64.exe" -outfile "./Downloads/Anaconda3-2024.10-1-Windows-x86_64.exe"</p>
            <br /><br /><p className='text-[8px] pl-2'>
            * recomended if you want to use different Python version<br />
            ** If you already installed before, remove file<br />
            Check opt/Usr/ at opt, probably there are homebrew and anaconda3
            </p>
            <p className='bg-gray-100 text-[8px] pl-2 p-1 w-[350px]'>open .</p>
            <p className='text-[8px] pl-2'>and remove anaconda3.</p><br /><br /> */}
            At server.py, paste this.
            <pre class="primary-code-container">
               {serverpy_template}
            </pre>
            <br />
            Run backend.<br />
            <pre className='primary-code-container'>
               python3 server.py
            </pre><br />
             Access localhost:5000 on your browser to check if Hello Word text is displayed.
         </div>
         <p className='text-xs mb-12'>
            <b>2. Create account to get token for AI services</b><br />
            OpenAI, Huggingface etc.. sometimes you need to purchase $5 to get LLM token.<br /><br />
            <b className='text-[8px]'>Resource:</b><br />
            <RouterLink className='text-[8px]' to='https://huggingface.co'>huggingface https://huggingface.co</RouterLink><br />
            <RouterLink className='text-[8px]' to='https://huggingface.co'>open AI</RouterLink><br />
            <RouterLink className='text-[8px]' to='https://huggingface.co'>Claude</RouterLink><br />
            <RouterLink className='text-[8px]' to='https://huggingface.co'>Mistral</RouterLink><br />
         </p>
         <p className='text-xs mb-12'>
            <b>3. Paste purchased codes to add at server.py file.</b><br />
            If you are fullstack, paste code to existed py file. If you are backender, you can install jupyter lab or use google colab to paste and try run code.<br />
            You can try from trial codes andd see if it's works.
         </p>
         <p className='text-xs mb-12'>
            <b>4. Once you checked compoenent is working, study how it works and arange it to your version.</b><br />
            Check code of conduct to see professinal developer rules.<br /><RouterLink className='text-[8px] underline' to='../code-of-conduct'>code of conduct</RouterLink>
         </p>
      </div>
   )
}